import { render, staticRenderFns } from "./VaAccordion.demo.vue?vue&type=template&id=3419088e&"
import script from "./VaAccordion.demo.vue?vue&type=script&lang=js&"
export * from "./VaAccordion.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports